import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { getCommission, updateCommission } from '../../../Services/AdminServices/AdminCommissionServices';
import { MdModeEditOutline } from 'react-icons/md';
import { Button, Form, Modal } from 'react-bootstrap';
import { LoaderIcon } from 'react-hot-toast';

const Commission = () => {

    const [filterText, setFilterText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [level_1, setLevel_1] = useState("")
    const [level_2, setLevel_2] = useState("")
    const [id, setId] = useState("")
    const handleChangeLevel1 = (e) => { setLevel_1(e.target.value) }
    const handleChangeLevel2 = (e) => { setLevel_2(e.target.value) }
    const [loading, setLoading] = useState(false)
    const [commission, setCommission] = useState(null)
    const [withdrawableDuration, setWithdrawableDuration] = useState(null)
    const [minimumAmount, setMinimumAmount] = useState(null)

    const columns = [
        // { name: 'Item', selector: row => row.item },
        { name: 'Level 1', selector: row => row.level_1 },
        { name: 'Level 2', selector: row => row.level_2 },
        // { name: 'Level 3', selector: row => row.level_3 },
        {
            // name: 'Withdrawal Request',
            cell: row => (
                <Button onClick={() => handleShow(row?.id)} variant='outline-primary' size='sm'>
                    <MdModeEditOutline size={22} />

                </Button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },

    ];

    const columns2 = [
        { name: 'Title', selector: row => row.item },
        { name: 'Duration Time', selector: row => row.level_1.split('.')[0] },
        // { name: 'Level 2', selector: row => row.level_2 },
        // { name: 'Level 3', selector: row => row.level_3 },
        {
            name: '',
            cell: row => (
                <Button onClick={() => handleShow(row?.id)} variant='outline-primary' size='sm'>
                    <MdModeEditOutline size={22} />

                </Button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },

    ];

    const columns3 = [
        { name: 'Title', selector: row => row.item },
        { name: 'Amount', selector: row => row.level_1 },
        // { name: 'Level 2', selector: row => row.level_2 },
        // { name: 'Level 3', selector: row => row.level_3 },
        {
            name: '',
            cell: row => (
                <Button onClick={() => handleShow(row?.id)} variant='outline-primary' size='sm'>
                    <MdModeEditOutline size={22} />

                </Button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },

    ];

    const handleShow = (id) => {
        setId(id)
        setShow(true)
    };


    const handleGetCommission = async () => {
        setLoading(true)
        const response = await getCommission();
        if (response?.code === 200) {
            setData(response?.result?.settings)
            setCommission(response?.result?.settings[0])
            setWithdrawableDuration(response?.result?.settings[1])
            setMinimumAmount(response?.result?.settings[2])
            setLoading(false)
        }
        setLoading(false)
    }


    const handleSubmit = async () => {
        let body = {
            level_1,
            level_2: level_2 ? level_2 : 0
        }
        setLoading(true)
        let response = await updateCommission(id, body)
        if (response?.code === 200) {
            setLevel_1("")
            setLevel_2("")
            setLoading(false)
            setShow(false)
            handleGetCommission();
        }
    }

    // useEffect(() => {
    //     const filtered = data.filter(item =>
    //         Object.values(item).some(value =>
    //             String(value).toLowerCase().includes(filterText.toLowerCase())
    //         )
    //     );
    //     setFilteredData(filtered);
    // }, [filterText, data]);

    useEffect(() => { handleGetCommission(); }, [])



    return (
        <>

            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className='fw-bold mb-0'>Commission</h3>
                        <p className='text-muted'>Manage user commission level</p>
                    </div>
                </div>

                <div>

                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <div className="spinner-border text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>) :
                        (
                            <>

                                <div className='text-end d-none'>
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        value={filterText}
                                        onChange={e => setFilterText(e.target.value)}
                                        style={{
                                            marginBottom: '10px',
                                            padding: '8px',
                                            width: '300px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc'
                                        }}
                                    />
                                </div>
                                <DataTable
                                    columns={columns}
                                    data={commission ? [commission] : []}
                                    // pagination
                                    highlightOnHover
                                    striped
                                />
                            </>
                        )}
                </div>

            </div>

            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className='fw-bold mb-0'>Withdrawal Duration</h3>
                        <p className='text-muted'>Manage user withdrawal duration level</p>
                    </div>
                </div>

                <div>

                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <div className="spinner-border text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>) :
                        (
                            <>

                                <div className='text-end d-none'>
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        value={filterText}
                                        onChange={e => setFilterText(e.target.value)}
                                        style={{
                                            marginBottom: '10px',
                                            padding: '8px',
                                            width: '300px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc'
                                        }}
                                    />
                                </div>
                                <DataTable
                                    columns={columns2}
                                    data={withdrawableDuration ? [withdrawableDuration] : []}
                                    // pagination
                                    highlightOnHover
                                    striped
                                />
                            </>
                        )}
                </div>


            </div>


            <div className="container py-5">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className='fw-bold mb-0'>Minimum Amount</h3>
                        <p className='text-muted'>Manage your minmum amount</p>
                    </div>
                </div>

                <div>

                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <div className="spinner-border text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>) :
                        (
                            <>

                                <div className='text-end d-none'>
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        value={filterText}
                                        onChange={e => setFilterText(e.target.value)}
                                        style={{
                                            marginBottom: '10px',
                                            padding: '8px',
                                            width: '300px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc'
                                        }}
                                    />
                                </div>
                                <DataTable
                                    columns={columns3}
                                    data={minimumAmount ? [minimumAmount] : []}
                                    // pagination
                                    highlightOnHover
                                    striped
                                />
                            </>
                        )}
                </div>
            </div>







            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: "16px " }}>

                        {
                            id === 1 && "Edit Commission"
                        }

                        {
                            id === 2 && "Edit Duration"
                        }

                        {
                            id === 3 && "Edit Amount"
                        }

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {
                        id === 1 && (
                            <Form>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Level 1</Form.Label>
                                    <Form.Control value={level_1} onChange={handleChangeLevel1} type="number" placeholder="XX%" />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Level 2</Form.Label>
                                    <Form.Control value={level_2} onChange={handleChangeLevel2} type="number" placeholder="XX%" />
                                </Form.Group>
                            </Form>
                        )
                    }



                    {
                        id === 2 && (
                            <Form>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Duration In days</Form.Label>
                                    <Form.Control value={level_1} onChange={handleChangeLevel1} type="number" placeholder="XX%" />
                                </Form.Group>
                            </Form>
                        )
                    }


                    {
                        id === 3 && (
                            <Form>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Minimum Amount</Form.Label>
                                    <Form.Control value={level_1} onChange={handleChangeLevel1} type="number" placeholder="XX%" />
                                </Form.Group>
                            </Form>
                        )
                    }

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size='sm' onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" size='sm' onClick={handleSubmit}>
                        {loading ? <LoaderIcon /> : "Save Changes"}
                    </Button>
                </Modal.Footer>
            </Modal>


        </>
    )
}

export default Commission